__turbopack_context__.v({
  "checkbox-container": "checkboxGroupField-module-scss-module__HoC5Qa__checkbox-container",
  "checkbox-group": "checkboxGroupField-module-scss-module__HoC5Qa__checkbox-group",
  "container": "checkboxGroupField-module-scss-module__HoC5Qa__container",
  "error": "checkboxGroupField-module-scss-module__HoC5Qa__error",
  "error-msg": "checkboxGroupField-module-scss-module__HoC5Qa__error-msg",
  "errorContainer": "checkboxGroupField-module-scss-module__HoC5Qa__errorContainer",
  "errorContent": "checkboxGroupField-module-scss-module__HoC5Qa__errorContent",
  "errorIcon": "checkboxGroupField-module-scss-module__HoC5Qa__errorIcon",
  "hint": "checkboxGroupField-module-scss-module__HoC5Qa__hint",
  "label": "checkboxGroupField-module-scss-module__HoC5Qa__label",
  "label-disabled": "checkboxGroupField-module-scss-module__HoC5Qa__label-disabled",
  "textContainer": "checkboxGroupField-module-scss-module__HoC5Qa__textContainer",
});
